






































import { Vue, Component, Prop, Emit, Ref } from "vue-property-decorator";
import { vxm } from "@/store";

@Component({})
export default class AddBonusDialog extends Vue {
  @Prop() value!: boolean;
  @Ref("form") form: any;

  visible = false;
  valid = false;
  loading = false;

  score = "";
  comment = "";
  scoreRules = [(v: string) => !!v || "Please enter a score", (v: string) => !/[^0-9-]/.test(v) || "Please enter an integer score"];
  commentRules = [(v: string) => !v || v.length < 255 || "Please keep your comment under 255 characters"];

  @Emit("input")
  close() {
    return false;
  }

  async submit() {
    await this.form.validate();

    if (!this.valid) {
      return;
    }

    try {
      this.loading = true;

      await vxm.results.addBonus({
        score: parseInt(this.score),
        comment: this.comment
      });

      this.form.reset();
      this.close();
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }
}
